import React from 'react';
import { graphql } from "gatsby"
import { Asset, Link } from "../../../../plugins/gatsby-plugin-atollon";

const SunnyPromoBanner = ({ productImage, image, button, title, price }) => {
  return (
    <section className="sunny-promo-banner">
      <div className="sunny-promo-banner__inner">
        <div className="sunny-promo-banner__product">
          <Asset asset={productImage} />
        </div>
        <div className="sunny-promo-banner__content">
          <h1>{title}</h1>
          <p>{price}</p>
          <Link {...button} className='btn'>{button[0].title}</Link>
        </div>
      </div>
      <div className="sunny-promo-banner__image">
        <Asset asset={image} />
      </div>
    </section>
  )
}

export default SunnyPromoBanner;

export const query = graphql`
  fragment SunnyPromoBannerProps on DatoCmsSunnyPromoBanner {
    ... on DatoCmsSunnyPromoBanner {
      id
      productImage {
        ...InternalAssetProps
      }
      image {
        ...InternalAssetProps
      }
      title
      price
      button {
        ...LinkWithTitleProps
      }
    }
  }
`